import { z } from 'zod'
import { makeDataResponseSchema, messageResponseSchema } from '../../api/base-schemas'

export const loginResponseSchema = makeDataResponseSchema(
  z.object({
    employee_id: z.string().optional(),
    employee_name: z.string().optional(),
    user_id: z.string().optional(),
    user_name: z.string().optional(),
    company_id: z.string().optional(),
    access_token: z.string(),
    refresh_token: z.string(),
    expires_in: z.number(),
  }),
)

export const logoutResponseSchema = messageResponseSchema

export const forgotPasswordResponseSchema = messageResponseSchema

export const validateRecoveryCodeResponseSchema = makeDataResponseSchema(
  z.object({
    valid: z.boolean(),
  }),
)

export const resetPasswordResponseSchema = messageResponseSchema

export const refreshTokenResponseSchema = makeDataResponseSchema(
  z.object({
    access_token: z.string(),
    expires_in: z.number(),
  }),
)

export const resendRecoveryCodeResponseSchema = messageResponseSchema
